import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateMethods, isValidDate } from '../../../utils/dates/dateMethods';
import DatePickerInputMask from '../../../lib/inputs/react-datepicker/DatePickerInputMask';

const DatePickerStyled = styled.div`
    .date-picker-icon {
        float: left;
        margin-left: 2px;
        margin-top: -38px;
        position: relative;
        height: 36px;
        width: 40px;
        padding: 10px;
        background-color: #eeeef4;
    }

    input {
        width: 100%;
        padding: 8px 12px 8px 60px;
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 4px;
        outline: none;
    }
`;

export const DateInput: React.FC<any> = ({ id, value, onChange }) => {
    const [date, setDate] = useState<string>(value);

    useEffect(() => {
        setDate(dateMethods.getDateFormatted(value));
    }, [value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDate(e.target.value);

        if (!isValidDate(e.target.value)) {
            return;
        }

        const val = new Date(e.target.value);
        onChange?.(val);
    };

    const handleBlur = () => {
        if (!isValidDate(date)) {
            setDate(dateMethods.getDateFormatted(value));
        }
    };

    return (
        <DatePickerStyled>
            <DatePickerInputMask
                id={id}
                value={date}
                disabled={false}
                onChange={handleInputChange}
                onBlur={handleBlur}
            />
            <FontAwesomeIcon icon="calendar-alt" className="date-picker-icon" />
        </DatePickerStyled>
    );
};
